import React from 'react';
import { Button } from 'antd';
import { BasicText } from '@components';

const BasicButton = (props) => {
  return (
    <Button
      {...props}
      onClick={() => props.onClick()}
    >
      <BasicText bold={props.bold} color={props.color} fontSize={props.fontSize ? props.fontSize : "14px"}>
        {props.text}
      </BasicText>
    </Button>
  )
}

export default BasicButton;
